import React, { FunctionComponent } from 'react';

import styled, { css } from 'styled-components';

import Typography from '@components/basics/typography';
import theme from '@webapp/theme';

interface PillProps {
  className?: string;
  bordered?: boolean;
}

const Pill: FunctionComponent<PillProps> = ({ className, children }) => {
  return (
    <div className={className || ''}>
      <Typography type="small" weight="700">
        {children}
      </Typography>
    </div>
  );
};

export default styled(Pill)`
  background-color: ${({ theme }) => theme.colors.purple};
  padding: 3px 6px;
  border-radius: 90px;

  span {
    color: ${({ theme }) => theme.colors.white};
    line-height: ${({ theme }) => theme.typography.span};
  }

  ${(props) =>
    props.bordered
      ? css`
          background-color: transparent;
          border: 1px solid ${theme.colors.primary};

          span {
            color: ${({ theme }) => theme.colors.primary};
          }
        `
      : null}
`;
